import {mcpServerSvg as Icon__small__mcpServerSvg} from '../Icon__small/Icon__small--mcpServer.js';

export var mcpServer = {
  name: 'mcpServer',
  category: 'icon',
  colorable: true,
  svg: Icon__small__mcpServerSvg,
};
